import React, { useEffect, useState } from 'react';
import ListinngCard from '../../layouts/ListingCard';
import { Form, message } from 'antd';
import { InputField } from '../../layouts/FormFields';
import { app } from '../../config';
import axios from 'axios';
import getHeaders from '../../utils/authHeaders';

const BetaSignUpUser = () => {
  const tableHeaders = ['Email', 'Status', ''];
  const [loader, setLoader] = useState(false);
  const [tableBody, setTableBody] = useState([]);
  //  const [isRender, setisRender] = useState(false);

  const [pageSize, setPageSize] = useState(10);
  const [pagesCount, setPagesCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [form] = Form.useForm();

  const getListing = async (formData) => {
    try {
      setLoader(true);
      const res = await axios.get(`${app.URL}/api/v1/admin/beta/listing?limit=${formData.limit}&offset=${formData.offset}`, { headers: getHeaders() });
      console.log('response is:', res);
      res.data.result.data ? setPagesCount(res.data.result.data.count) : ' ';
      res.data.result.data ? setLoader(false) : ' ';
      res.data.result.data ? setTableBody(res?.data?.result?.data?.data) : ' ';
      console.log('Data', res?.data?.result);
      message.info(res?.data?.result?.msg);
    } catch (err) {
      console.log(err);
    }
  };

  const onPageChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setPageSize(pageSize);
    setCurrentPage(page);
    if (!page) page = 1;
    let limit = pageSize;
    try {
      let reqObj = {
        limit: limit,
        offset: limit * (page - 1),
      };
      console.log('page Changed', reqObj);
      await getListing(reqObj);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      //  setTableShow(false);
    }
  };

  useEffect(() => {
    let formData = { limit: pageSize, offset: 0 };
    const fetchData = async () => {
      await getListing(formData);
    };
    fetchData();
  }, []);

  const onFormFinish = async (values) => {
    try {
      let res = await axios.post(`${app.URL}/api/v1/admin/beta/create`, { email: values?.Email }, { headers: getHeaders() });
      if (res?.data?.result?.success) {
        let formData = { limit: 10, offset: 0 };
        message.success(res?.data?.result?.msg);
        await getListing(formData);
        form.resetFields();
      }
    } catch (error) {
      console.log(error);
      message.error(error?.response?.data?.result?.msg);
    }
  };

  const onDelete = async (email) => {
    try {
      let res = await axios.delete(`${app.URL}/api/v1/admin/beta/deleteuser?email=${email}`, { headers: getHeaders() });
      if (res?.data?.result?.success) {
        let formData = { limit: 10, offset: 0 };
        message.success(res?.data?.result?.msg);
        await getListing(formData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <ListinngCard
        heading='Beta User Signup'
        addBetaUser={
          <Form form={form} name='basic' onFinish={onFormFinish} autoComplete='off' className='row p-3 pb-0'>
            <InputField
              col='col-md-3 col-6'
              type={'email'}
              name='Email'
              rules={[
                {
                  required: true,
                  message: 'Please Enter Email',
                },
              ]}
              placeholder='Email'
              label='Email'
              required={true}
            />
            <div className='col-md-3 col-12  d-flex align-items-center '>
              <button type='primary' class='btn w-50 btn-primary button ' style={{ marginTop: '-0.3rem' }} htmlType='submit'>
                Add
              </button>
            </div>
          </Form>
        }
        tableHeaders={tableHeaders}
        tableRows={tableBody}
        notShowSearch={true}
        onPageChange={onPageChange}
        currentPage={currentPage}
        pagesCount={pagesCount}
        patientsListing={false}
        inventoryListing={false}
        storeListing={false}
        productListing={false}
        userListings={false}
        betaUserListing={true}
        onDelete={onDelete}
        feedbackListing={false}
        bannerListing={false}
        loader={loader}
      />
    </>
  );
};

export default BetaSignUpUser;
